import React from 'react';

export const CaretRightIcon: React.FC<{ size?: number }> = ({ size = 10 }) => (
  <svg width={size} height={size} viewBox="0 0 10 10" aria-hidden="true">
    <path d="M2 1 L8 5 L2 9 Z" fill="currentColor" />
  </svg>
);

export const CaretDownIcon: React.FC<{ size?: number }> = ({ size = 10 }) => (
  <svg width={size} height={size} viewBox="0 0 10 10" aria-hidden="true">
    <path d="M1 2 L9 2 L5 8 Z" fill="currentColor" />
  </svg>
);
